import { FormEvent, ReactElement, Ref } from "react";
import { ComboboxProps } from "@twilio-paste/core/combobox";
import { Margin, Width } from "@twilio-paste/core/style-props";

/**
 * Here we're omitting the 'onChange' prop from Paste ComboboxProps because
 * we want to extend them, but also want to surface our own 'onChange' method
 * in the ComboboxSearch component. This will never be passed to the Combobox
 * component from Paste itself, but will allow our devs to have a familiar
 * component API for our own development.
 */
type AdjustedComboboxProps = Omit<ComboboxProps, "onChange">;

export interface ComboboxSearchProps extends AdjustedComboboxProps {
  id?: string;
  onChange: (value: string) => void;
  onSelectItem: (item: any) => void;
  ref?: Ref<HTMLInputElement>;
  value: string;
  selectedItem?: string;
}

export interface SearchInputProps {
  submitVariant?: SearchInputSubmitVariant;
  errorText?: string;
  id: string;
  isLoading?: boolean;
  hasError?: boolean;
  helpText?: string;
  inputWidth?: Width;
  label?: string;
  marginBottom?: Margin;
  required?: boolean;
  width?: Width;
  onChange: (inputValue: string) => void;
  onSelectItem: (item: any) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => Promise<void>;
  onTrackSearchSubmit?: () => void;
  placeholder?: string;
  value: string;
  // Any is acceptable here as this is what Paste is using under-the-hood
  querySuggestions?: any[];
  querySuggestionsItemRender: (item: any) => ReactElement;
  selectedItem?: string;
}

export enum SearchInputSubmitVariant {
  button = "button",
  inputButton = "inputButton",
}
